export const isAuthenticated = () => {
    if(typeof window == 'undefined'){
        return false
    }
    if(localStorage.getItem('token')){
        return JSON.parse(localStorage.getItem('token'))
    }else{
        return false
    }
}

export const authenticateUser = () => {
    if(typeof window == 'undefined'){
        return false
    }
    if(localStorage.getItem('userInfo')){
        return JSON.parse(localStorage.getItem('userInfo'))
    }else{
        return false
    }
}